const uiLabels = JSON.parse(document.querySelector('#finxful-ui-labels')?.textContent || '{}');
const menuButton = document.querySelector('#menu-toggle');
const menu = document.querySelector('#mobile-nav');
function closeMenu() {
  menu.hidden = true;
  menuButton.setAttribute('aria-expanded', 'false');
  menuButton.setAttribute('aria-label', (uiLabels.menuOpen || 'Menü öffnen'));
  menuButton.title = (uiLabels.menuOpen || 'Menü öffnen');
}
menuButton.addEventListener('click', () => {
  const open = menu.hidden;
  menu.hidden = !open;
  menuButton.setAttribute('aria-expanded', String(open));
  menuButton.setAttribute('aria-label', open ? (uiLabels.menuClose || 'Menü schließen') : (uiLabels.menuOpen || 'Menü öffnen'));
  menuButton.title = open ? (uiLabels.menuClose || 'Menü schließen') : (uiLabels.menuOpen || 'Menü öffnen');
});
menu.querySelectorAll('a').forEach(a => a.addEventListener('click', closeMenu));
document.addEventListener('keydown', event => { if (event.key === 'Escape' && !menu.hidden) { closeMenu(); menuButton.focus(); } });
const video = document.querySelector('#hero-video');
const videoButton = document.querySelector('#video-toggle');
const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
if (video && videoButton) {
function updateVideoControl() {
  const label = video.paused ? (uiLabels.videoPlay || 'Hintergrundvideo abspielen') : (uiLabels.videoPause || 'Hintergrundvideo pausieren');
  videoButton.setAttribute('aria-label', label);
  videoButton.title = label;
  videoButton.innerHTML = video.paused ? '<i data-lucide="play"></i>' : '<i data-lucide="pause"></i>';
  if (window.lucide) lucide.createIcons();
}
videoButton.addEventListener('click', () => {
  if (video.paused) video.play().catch(updateVideoControl);
  else video.pause();
});
video.addEventListener('play', updateVideoControl);
video.addEventListener('pause', updateVideoControl);
video.addEventListener('error', () => { videoButton.hidden = true; });
if (reducedMotion.matches) video.pause();
reducedMotion.addEventListener('change', event => { if (event.matches) video.pause(); });
updateVideoControl();
}
const sticky = document.querySelector('#mobile-offer');
if (sticky) {
let heroVisible = true;
let productVisible = false;
let footerVisible = false;
const mobile = matchMedia('(max-width: 640px)');
function updateSticky() { sticky.hidden = !mobile.matches || heroVisible || productVisible || footerVisible; }
const observer = new IntersectionObserver(entries => {
  for (const entry of entries) {
    if (entry.target.id === 'start') heroVisible = entry.isIntersecting;
    else if (entry.target.id === 'produkt') productVisible = entry.isIntersecting;
    else footerVisible = entry.isIntersecting;
  }
  updateSticky();
});
for (const selector of ['#start','#produkt','footer']) {
  const target = document.querySelector(selector);
  if (target) observer.observe(target);
}
mobile.addEventListener('change', updateSticky);
}
if (window.lucide) lucide.createIcons();
